const FIREBASE_AUTH_MESSAGES: Record<string, string> = {
    'auth/popup-closed-by-user': 'Google sign-in was closed before it finished.',
    'auth/cancelled-popup-request': 'Google sign-in was cancelled.',
    'auth/popup-blocked': 'Your browser blocked the Google sign-in popup.',
    'auth/unauthorized-domain':
        'This site is not an authorized domain in Firebase. Add localhost and galiastandardpoodles.com.',
    'auth/operation-not-allowed': 'Google sign-in is not enabled yet in the Firebase console.',
    'auth/network-request-failed': 'Network error during Google sign-in. Try again.',
};

export const getGoogleSignInErrorMessage = (error: unknown): string => {
    if (error && typeof error === 'object' && 'code' in error) {
        const code = String((error as { code?: string }).code);
        if (FIREBASE_AUTH_MESSAGES[code]) {
            return FIREBASE_AUTH_MESSAGES[code];
        }
    }

    if (error instanceof Error && error.message) {
        return error.message;
    }

    return 'Google sign-in failed. Try again.';
};

const PASSWORD_AUTH_MESSAGES: Record<string, string> = {
    'auth/invalid-credential': 'That email or password is incorrect.',
    'auth/wrong-password': 'That email or password is incorrect.',
    'auth/user-not-found': 'That email or password is incorrect.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/too-many-requests': 'Too many attempts. Try again later.',
    'auth/operation-not-allowed': 'Email sign-in is not enabled yet in the Firebase console.',
};

export const getOwnerPasswordErrorMessage = (error: unknown): string => {
    if (error && typeof error === 'object' && 'code' in error) {
        const code = String((error as { code?: string }).code);
        if (PASSWORD_AUTH_MESSAGES[code]) {
            return PASSWORD_AUTH_MESSAGES[code];
        }
    }

    if (error instanceof Error && error.message) {
        return error.message;
    }

    return 'Sign-in failed. Try again.';
};
